module.exports = __webpack_public_path__ + "img/MarketingIcon.ce007d12.svg";